enum Direction {
  Top = 0x1,
  Left = 0x2,
  Bottom = 0x4,
  Right = 0x8,
}

export enum DragKinds {
  TopLeft = Direction.Top | Direction.Left,
  TopRight = Direction.Top | Direction.Right,
  BottomLeft = Direction.Bottom | Direction.Left,
  BottomRight = Direction.Bottom | Direction.Right,
  Left = Direction.Left,
  Top = Direction.Top,
  Right = Direction.Right,
  Bottom = Direction.Bottom,
  Self = 0x10,
  From = 0x40,
  To = 0x80,
}
